export default "/_next/static/images/9bd1af4723d11d831a6057eb8ec8e5e8.jpg";